// ==========================================
// Footer.jsx
// ==========================================
import badgerImage from '../assets/badger.png';

const Footer = ({ showFooter }) => {
  if (!showFooter) return null;

  return (
    <>
    <div className="footerText">
      Sponsored by <a href="https://narberthcoffee.co.uk/coffee/" title="Narberth Coffee">Narberth Coffee</a>.
      <a href="https://narberthcoffee.co.uk/coffee/" title="Narberth Coffee">
        <img src={badgerImage} alt="Narberth Coffee" className="badgerLogo" />
      </a>
    </div>
    </>
  );
};

export default Footer;